import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import { reportClientError } from './config/api';

// ── Global error handlers ────────────────────────────────────────────────────

// Catches synchronous errors and errors in event handlers not inside React
window.onerror = (message, source, lineno, colno, error) => {
  reportClientError({
    type: 'window.onerror',
    message: String(message),
    source,
    lineno,
    colno,
    stack: error?.stack,
  });
  return false; // let default browser handling continue
};

// Catches unhandled Promise rejections (e.g. async/await without try-catch)
window.onunhandledrejection = (event) => {
  reportClientError({
    type: 'unhandledrejection',
    message: event.reason?.message ?? String(event.reason),
    stack: event.reason?.stack,
  });
};

// ── Render ───────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
